enum PracovnyKrokEnum {
  VYTVORIT_SPRIEVODNY_DOKUMENT = 'VYTVORIT_SPRIEVODNY_DOKUMENT',
  ZRUSIT_MATERIAL = 'ZRUSIT_MATERIAL',
  PRECHOD_VYJADRENIA = 'PRECHOD_VYJADRENIA',
  ZRUSIT_NASTAVENE_VYJADRENIA = 'ZRUSIT_NASTAVENE_VYJADRENIA',
  UKONCIT_PROCES = 'UKONCIT_PROCES',
  UKONCIT_PROCES_BEZ_MPK = 'UKONCIT_PROCES_BEZ_MPK',
  PRECHOD_PREDP_FAZA_UKONC = 'PRECHOD_PREDP_FAZA_UKONC',
  NAVRAT_PRIPRAVA = 'NAVRAT_PRIPRAVA',
  UKONCIT_PROCES_POSLEDNE_STADIUM = 'UKONCIT_PROCES_POSLEDNE_STADIUM',
  PRECHOD_MPK = 'PRECHOD_MPK',
  PRECHOD_SPRACOVANIE_PREDKLADATEL = 'PRECHOD_SPRACOVANIE_PREDKLADATEL',
  VYTVORIT_PRIPOMIENKU = 'VYTVORIT_PRIPOMIENKU',
  ODOSLAT_BEZ_PRIPOMIENOK = 'ODOSLAT_BEZ_PRIPOMIENOK',
  VYHODNOTIT_PRIPOMIENKY = 'VYHODNOTIT_PRIPOMIENKY',
  ZRUSIT_MPK = 'ZRUSIT_MPK',
  UKONCIT_MPK_TEST = 'UKONCIT_MPK_TEST',
  SPUSTIT_ROKOVANIE_POV = 'SPUSTIT_ROKOVANIE_POV',
  UKONCIT_ROKOVANIE_POV = 'UKONCIT_ROKOVANIE_POV',
  SPUSTIT_ROKOVANIE_VLADY = 'SPUSTIT_ROKOVANIE_VLADY',
  UKONCIT_ROKOVANIE_VLADY = 'UKONCIT_ROKOVANIE_VLADY',
  NAVRAT_SPRACOVANIE_PREDKLADATEL = 'NAVRAT_SPRACOVANIE_PREDKLADATEL',
  OZNACIT_AKO_SCHVALENY = 'OZNACIT_AKO_SCHVALENY',
  OZNACIT_AKO_VZATY_SPAT = 'OZNACIT_AKO_VZATY_SPAT',
  OZNACIT_AKO_NESCHVALENY = 'OZNACIT_AKO_NESCHVALENY',
  PRECHOD_VYHLASENE_V_ZBIERKE = 'PRECHOD_VYHLASENE_V_ZBIERKE',
  PRECHOD_ROKOVANIE_NRSR = 'PRECHOD_ROKOVANIE_NRSR',
  OZNACIT_AKO_SCHVALENY_MINISTER = 'OZNACIT_AKO_SCHVALENY_MINISTER',
  OZNACIT_AKO_NESCHVALENY_MINISTER = 'OZNACIT_AKO_NESCHVALENY_MINISTER',
  URCIT_GESTOROV = 'URCIT_GESTOROV',
  DEFINOVAT_STUPEN_DOLEZITOSTI = 'DEFINOVAT_STUPEN_DOLEZITOSTI',
  ODOSLAT_NA_UVSR = 'ODOSLAT_NA_UVSR',
  SCHVALIT_GESTORA = 'SCHVALIT_GESTORA',
  SCHVALIT_GESTORA_PRESUN = 'SCHVALIT_GESTORA_PRESUN',
  ODMIETNUT_GESTORA = 'ODMIETNUT_GESTORA',
  DEFINOVAT_KATEGORIU = 'DEFINOVAT_KATEGORIU',
  NAMIETKA_K_URCENIU_GESTORSTVA = 'NAMIETKA_K_URCENIU_GESTORSTVA',
  ZRUSIT_NASTAVENE_MPK = 'ZRUSIT_NASTAVENE_MPK',
  PRECHOD_PRED_VYHLASENIM = 'PRECHOD_PRED_VYHLASENIM',
  PRECHOD_ZAPIS_DOPLNENEHO_PREDB_STANOVISKA = 'PRECHOD_ZAPIS_DOPLNENEHO_PREDB_STANOVISKA',
  PRECHOD_VYTVORENIE_FINAL_STANOVISKA = 'PRECHOD_VYTVORENIE_FINAL_STANOVISKA',
  PRECHOD_SCHVALOVANIE_MINISTROM = 'PRECHOD_SCHVALOVANIE_MINISTROM',
  ODOSLAT_PREDSEDOVI_VLADY = 'ODOSLAT_PREDSEDOVI_VLADY',
  UKONCIT_VYHODNOTENIE_MPK = 'UKONCIT_VYHODNOTENIE_MPK',
  UKONCIT_VYHODNOTENIE_MPK_AKTYEU = 'UKONCIT_VYHODNOTENIE_MPK_AKTYEU',
  ZVEREJNIT_NA_PORTALI = 'ZVEREJNIT_NA_PORTALI',
  SPRIEVODNY_DOKUMENT_FUNCTION = 'SPRIEVODNY_DOKUMENT_FUNCTION',
  PREDKLADATEL_UPDATE_FUNCTION = 'PREDKLADATEL_UPDATE_FUNCTION',
  ADMIN_ZMENA_STADIA_FUNCTION = 'ADMIN_ZMENA_STADIA_FUNCTION'
}

export default PracovnyKrokEnum;
